export const packList = [
"2pDuel.json",
"2pDuelSolo.json",
"3pDuel.json",
"fellowship.json",
"fellowshipSolo.json",
"trilogy.json",
"trilogyCoop.json",
];